import React, { useEffect } from "react";

export type SelectOption = { key: string; value: string };

const Select = (props: {
  id: string;
  options: SelectOption[];
  value?: string;
  disabled?: boolean;
  onChange?: (val: string) => void;
}) => {
  useEffect(() => {
    try {
      // @ts-ignore
      const select = $(".pyht-select#" + props.id).niceSelect();
      select.on("change", () => {
        if (props.onChange) {
          props.onChange(select.val());
        }
      });
    } catch (e) {
      console.warn(
        "Cannot initialise nice-select for PYHT: jQuery not available!"
      );
    }
    return () => {
      try {
        // @ts-ignore
        $(".pyht-select#" + props.id).niceSelect("destroy");
      } catch (e) {
        console.warn(
          "Cannot initialise nice-select for PYHT: jQuery not available!"
        );
      }
    };
  }, []);

  useEffect(() => {
    try {
      // @ts-ignore
      $(".pyht-select#" + props.id).niceSelect("update");
    } catch (e) {
      console.warn(
        "Cannot initialise nice-select for PYHT: jQuery not available!"
      );
    }
  }, [props.options, props.value, props.disabled]);

  return (
    <select
      className={"pyht-select"}
      disabled={props.disabled}
      id={props.id}
      value={props.value}
      onChange={(e) => props.onChange && props.onChange(e.target.value)}
    >
      {props.options.map((item) => {
        return (
          <option key={`option-${item.key}-${item.value}`} value={item.key}>
            {item.value}
          </option>
        );
      })}
    </select>
  );
};

export default Select;
